<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3 font-semibold">
    <label class="font-semibold uppercase category-name" translate>protocol.lbl_sites</label>
    @if(isAllowToAddProduct) {
    <div>
      <p-button class="flex align-items-center justify-content-center mr-2" icon="pi pi-plus" label="Add Protocol Site"
        (click)="onAddProtocolSite()"></p-button>
    </div>
    }
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="attributeLabels"
    [data]="tableData"
    entityName="site"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteSiteMsg"
    [header]="deleteSiteHeaderMsg"
    (onDelete)="onSiteDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    (onRowSelection)="onRowSelect($event)"
    [filterList]="[]"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAdd()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdateSite($event)"
    [rowItems]="rowItems"
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"
    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(isSiteReady && showAddProtocolSiteDialog) {
<p-dialog [header]="headerLabel" [modal]="true" [(visible)]="showAddProtocolSiteDialog" [style]="{ width: '60rem' }"
  (onHide)="onDialogClose()" (onShow)="onDialogShow()" (visibleChange)="onDialogVisibleChange($event)" [closable]="true"
  [closeOnEscape]="true">
  @if(showAddProtocolSiteDialog) {
  <app-add-protocol-site
    #addProtocolSite
    [protocolEntityId]="trialId"
    [protocolSiteId]="siteId"
    (saveSuccess)="onSaveSuccess()"
    [isChangeReasonNotRequired]="isChangeReasonNotRequired"
    [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus">
  </app-add-protocol-site>
  }
</p-dialog>
}